import { ViewLiveWebinarPage } from '@live-webinar/view';
import { RouterType } from '@online-webinar/router';

export const updateRoute = (router: RouterType) => {
    router.routesById['/$webinarId/w/$linkCode'].update({
        staticData: { title: { webinar: 'Title.WatchWebinar' } },
        component: ViewLiveWebinarPage
    });
};
